// @flow
import Cookies from "js-cookie";

import { getBasePathServer } from "../../constants/Settings";

type CookieOptions = {
  days?: number,
  sameSite?: "None" | "Lax" | "Strict",
  secure?: boolean,
};

type CookieAttributes = {
  path: string,
  expires?: number,
  sameSite?: string,
  secure?: boolean,
};

/**
 */
export const getCookie = (name: string): null | string => {
  return Cookies.get(name);
};

/**
 */
export const setCookie = (
  name: string,
  value: any,
  options?: CookieOptions,
) => {
  const attributes: CookieAttributes = { path: getBasePathServer() };
  attributes.expires = options?.days;
  attributes.sameSite = options?.sameSite ?? "Strict";
  attributes.secure = options?.secure;

  Cookies.set(name, value, attributes);
};

/**
 */
export const clearCookie = (name: string) => {
  Cookies.remove(name, { path: getBasePathServer() });
};
